/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Invoice_Transfer_DatedInputs */

const fr_api_invoice_transfer_dated = /** @type {(inputs: Api_Invoice_Transfer_DatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le virement de cette facture est daté : elle ne peut plus être supprimée.`)
};

const en_api_invoice_transfer_dated = /** @type {(inputs: Api_Invoice_Transfer_DatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This invoice’s transfer is dated, so it can no longer be deleted.`)
};

/**
* | output |
* | --- |
* | "This invoice’s transfer is dated, so it can no longer be deleted." |
*
* @param {Api_Invoice_Transfer_DatedInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const api_invoice_transfer_dated = /** @type {((inputs?: Api_Invoice_Transfer_DatedInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Invoice_Transfer_DatedInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_invoice_transfer_dated(inputs)
	return fr_api_invoice_transfer_dated(inputs)
});